import { SettingsContainer } from "../../../SettingsContainer";

import styles from "./SettingsPageSkeleton.module.scss";

type SettingsPageSkeletonProps = {
  rows: number;
  testId: string;
  hasMessage?: boolean;
};

export function SettingsPageSkeleton({
  rows,
  hasMessage = false,
  testId,
}: SettingsPageSkeletonProps) {
  return (
    <SettingsContainer testid={testId}>
      <div className={styles.skeletonContainer}>
        <div className={styles.skeletonButton} />
        <div className={styles.skeletonHeader} />
        {hasMessage && <div className={styles.skeletonMessage} />}
        {Array.from({ length: rows }).map((_, index) => (
          <div key={index}>
            <div className={styles.skeletonRow} />
            <div className={styles.skeletonRow} />
          </div>
        ))}
      </div>
    </SettingsContainer>
  );
}
